export enum ScrapingState {
  PENDING = 0,
  SCRAPING = 1,
  SCRAPED = 2,
  ERROR = 3
}
